var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-wrap",style:(_vm.cssVars),attrs:{"height":"100%","disabled":_vm.disabled,"ripple":false},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }